export default function Icon(params) {
    const { value, otherFields, data } = params;

    const iconCell = document.createElement('div');
    iconCell.classList.add('w5-icon-cell');

    const buildIcon = (val) => {
        const iconInfo = otherFields?.icons?.[val] || otherFields?.icon;
        if (!iconInfo?.svg && !iconInfo?.getSvg) return;

        const iconWrapper = document.createElement('div');
        iconWrapper.classList.add(`w5-icon-cell-wrapper`);
        iconWrapper.classList.add(`w5-icon-cell-${val}`);
        let svg;

        if (iconInfo.svg) svg = iconInfo.svg;
        else if (iconInfo.getSvg) svg = iconInfo.getSvg(params.data);

        if (!svg) return;

        iconWrapper.innerHTML = svg;

        if (iconInfo?.onClick) {
            iconWrapper.addEventListener('click', (event) => {
                iconInfo.onClick(event, data);
            });
            iconWrapper.classList.add(`w5-icon-cell-pointer`);
        }
        iconCell.appendChild(iconWrapper);
        if (iconInfo?.className) {
            iconCell.classList.add(iconInfo.className);
        }
    };

    if (!Array.isArray(value)) {
        buildIcon(value);
    } else {
        value.forEach((current) => buildIcon(current));
    }

    return iconCell;
}
